import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';

const _getRatings = (state) => state.get('ratings');

export const isRating = createSelector([_getRatings], (rating) =>
  Boolean(rating),
);

export const getRatingsScore = (state) =>
  _getRatings(state) &&
  _getRatings(state).get('score') &&
  _getRatings(state).get('score') / 10;
export const getRatingsScoreDescription = (state) =>
  state.getIn(['ratings', 'score_description']);

export const getRatingsList = createSelector(
  _getRatings,
  (list) =>
    list && list.get('category_list') && list.get('category_list').toJS(),
);
export const getRatingsCount = createSelector(
  [getRatingsList],
  (list) => list && list.reduce((acc, item) => acc + item.count, 0),
);
export const getGoodToKnowList = createSelector(
  _getRatings,
  (list) =>
    list &&
    list.get('good_to_know_list') &&
    list.get('good_to_know_list').toJS(),
);
export const getRatingsBadgeListHotel = createSelector(
  _getRatings,
  (ratings) => {
    if (!ratings) {
      return null;
    }

    const badgeList =
      ratings.get('badge_list') && ratings.get('badge_list').toJS();

    if (isEmpty(badgeList)) {
      return [];
    }

    return badgeList.filter(
      (item) => item.badge_type === 'hotel_type' && item.badge_data.score >= 80,
    );
  },
);

export const getRatingText = (state) =>
  _getRatings(state) && _getRatings(state).get('text');
